// @flow
import ScreenshotsViewerModal from './ScreenshotsViewerModal';

export default ScreenshotsViewerModal;
